import { render, staticRenderFns } from "./uploadhandovervoucher.vue?vue&type=template&id=87410afc&scoped=true&"
import script from "./uploadhandovervoucher.vue?vue&type=script&lang=js&"
export * from "./uploadhandovervoucher.vue?vue&type=script&lang=js&"
import style0 from "./uploadhandovervoucher.vue?vue&type=style&index=0&id=87410afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87410afc",
  null
  
)

export default component.exports